<label [ngClass]="config.cssClassesLabel">
  {{ config.label }}&nbsp;<sup *ngIf="this.isRequiredEffective()" class="required-mark">*</sup>&nbsp;<i
    class="o-btn-tooltip-help"
    *ngIf="config.toolTip"
    [title]="config.toolTip"
    placement="auto">?</i>
</label>
